import { usePublishedData } from "../lib/published-data";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { DocumentContent } from "../components/document-content";
import { documentHead, useShell } from "../lib/document-route";
import { guideHead } from "../components/matchups/guide-head";
import { GuidePage } from "../components/matchups/guide-page";
import { loadMatchupGuide } from "../server/matchups";

/** One section of a matchup guide (early, mid or late game, setup), asked for afresh each visit. */
export const Route = createFileRoute("/matchups/$slug/$section")({
  loader: async ({ params }) => {
    const guide = await loadMatchupGuide({ data: { slug: params.slug, section: params.section } });
    if (!guide) throw notFound();
    if (guide.kind === "redirect") throw redirect({ href: guide.to, statusCode: 302 });
    return guide;
  },
  staleTime: 0,
  gcTime: 0,
  head: ({ matches, loaderData, match }) =>
    loaderData?.kind === "page"
      ? documentHead(matches, loaderData, match.pathname, {
          title: (shell) => shell.creator.name,
          description: () => "",
        })
      : guideHead(matches, loaderData),
  component: Section,
});

function Section() {
  const initial = Route.useLoaderData();
  const shell = useShell();
  const { data: guide } = usePublishedData(
    initial,
    shell,
    `/matchups/${Route.useParams().slug}/${Route.useParams().section}`,
    "page",
  );
  if (guide.kind === "page") return <DocumentContent data={guide} shell={shell} />;
  return <GuidePage guide={guide} view="simple" />;
}
